// OP-3617 — Regras puras da tela Hoje: o que espera decisão, agrupado por quem
// decide. Os contadores vêm prontos do servidor (`getEstoqueHoje`), já no
// escopo de praça; aqui só a forma de mostrá-los.
import { HojeContadores, StatusBaixa, StatusInventario, StatusSolicitacao, StatusTransferencia } from '../../../../types/estoque'

/** Âmbar para o que espera; vermelho só para o que já passou do prazo. */
export type Severidade = 'atencao' | 'critico'

export interface LinhaHoje {
  chave: keyof HojeContadores
  rotulo: string
  total: number
  rota: string
  severidade: Severidade
}

export type GrupoHojeId = 'logistica' | 'coordenacao' | 'gerencia'

export interface GrupoHoje {
  id: GrupoHojeId
  titulo: string
  descricao: string
  linhas: LinhaHoje[]
}

const n = (v: unknown): number => Number(v) || 0

/** Janela padrão do servidor; vale quando o valor não vem ou não é um número positivo. */
export const JANELA_PADRAO_DIAS = 7

const linha = (
  c: HojeContadores, chave: keyof HojeContadores, rotulo: string, rota: string, severidade: Severidade = 'atencao',
): LinhaHoje => ({ chave, rotulo, total: n(c[chave]), rota, severidade })

const fila = (status: StatusSolicitacao) => `/interno/estoque/fila?status=${status}`
const transferencias = (status: StatusTransferencia) => `/interno/estoque/transferencias?status=${status}`
const inventarios = (status: StatusInventario) => `/interno/estoque/inventarios?status=${status}`
const baixas = (status: StatusBaixa) => `/interno/estoque/baixas?status=${status}`

export function gruposDoHoje(c: HojeContadores, janelaDias: number | null | undefined): GrupoHoje[] {
  const dias = n(janelaDias) > 0 ? n(janelaDias) : JANELA_PADRAO_DIAS
  return [
    {
      id: 'logistica',
      titulo: 'Logística',
      descricao: 'Pedidos, remessas, transferências em curso e o que ficou pelo caminho.',
      linhas: [
        linha(c, 'pedidosEmAnalise', 'Pedidos em análise', fila('EM_ANALISE')),
        linha(c, 'pedidosAguardandoInfo', 'Aguardando informação do solicitante', fila('AGUARDANDO_INFO')),
        linha(c, 'pedidosAprovados', 'Pedidos aprovados (a separar)', fila('APROVADA')),
        linha(c, 'pedidosEmSeparacao', 'Pedidos em separação', fila('EM_SEPARACAO')),
        linha(c, 'pedidosEmEspera', 'Pedidos em espera', fila('EM_ESPERA')),
        linha(c, 'pedidosProntos', 'Pedidos prontos (a expedir)', fila('PRONTA')),
        linha(c, 'remessasAtrasadas', 'Remessas atrasadas', '/interno/estoque/remessas', 'critico'),
        linha(c, 'remessasVencendo', `Remessas vencendo em ${dias} ${dias === 1 ? 'dia' : 'dias'}`, '/interno/estoque/remessas'),
        linha(c, 'transferenciasAprovadas', 'Transferências aprovadas (a separar)', transferencias('APROVADA')),
        linha(c, 'transferenciasEmSeparacao', 'Transferências em separação', transferencias('EM_SEPARACAO')),
        linha(c, 'transferenciasEmTransito', 'Transferências em trânsito (aguardando recebimento)', transferencias('EM_TRANSITO')),
        linha(c, 'transferenciasAguardandoConferencia', 'Transferências aguardando conferência', transferencias('RECEBIDA')),
        linha(c, 'extraviadasSemProposta', 'Extraviadas sem proposta de baixa', '/interno/estoque/baixas#sem-proposta'),
        linha(c, 'ocorrenciasAbertas', 'Ocorrências abertas', '/interno/estoque/ocorrencias'),
        linha(c, 'inventariosEmContagem', 'Inventários em contagem', inventarios('EM_CONTAGEM')),
      ],
    },
    {
      id: 'coordenacao',
      titulo: 'Coordenação',
      descricao: 'Aprovações que só a coordenação assina.',
      linhas: [
        linha(c, 'transferenciasAguardandoAprovacao', 'Transferências aguardando aprovação', transferencias('SOLICITADA')),
        linha(c, 'inventariosAguardandoAprovacao', 'Inventários aguardando aprovação', inventarios('AGUARDANDO_APROVACAO')),
      ],
    },
    {
      id: 'gerencia',
      titulo: 'Gerência',
      descricao: 'Tirar do patrimônio é decisão da gerência.',
      linhas: [
        linha(c, 'baixasPendentes', 'Baixas pendentes', baixas('PROPOSTA')),
      ],
    },
  ]
}

export const totalDoGrupo = (g: Pick<GrupoHoje, 'linhas'>): number => g.linhas.reduce((a, l) => a + l.total, 0)
